import React from "react";
import { LucideIcon } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@shared/ui/card";
import { EmptyState } from "./emptyState";
import { SectionWrapperProps } from "../../types";

export const SectionWrapper: React.FC<SectionWrapperProps> = ({
  title,
  subtitle,
  icon: Icon,
  isEmpty,
  emptyStateProps,
  children,
  className = "",
  variant = "card",
}) => {
  const header = (
    <div className="flex items-center justify-between">
      <div>
        <div className="flex items-center gap-2">
          {Icon && <Icon className="h-5 w-5 text-primary" />}
          <h3 className="text-lg font-medium">{title}</h3>
        </div>
        {subtitle && (
          <p className="text-sm text-muted-foreground mt-1">{subtitle}</p>
        )}
      </div>
    </div>
  );

  const content = () => {
    if (isEmpty) {
      return (
        <EmptyState
          icon={emptyStateProps?.icon}
          title={emptyStateProps?.title}
          description={emptyStateProps?.description}
          action={emptyStateProps?.action}
        />
      );
    }

    return children;
  };

  if (variant === "card") {
    return (
      <Card className={className}>
        <CardHeader className="pb-4">
          <CardTitle className="text-lg">{header}</CardTitle>
        </CardHeader>
        <CardContent>{content()}</CardContent>
      </Card>
    );
  }

  return (
    <div className={`rounded-lg border bg-card p-5 shadow-sm ${className}`}>
      <div className="mb-6">{header}</div>
      {content()}
    </div>
  );
};
